import Model, { attr } from '@ember-data/model';

export default Model.extend({
  uploadAll: attr('boolean'),
  entitiesFileName: attr('string'),
  fundsFileName: attr('string'),
  fundBalancesFileName: attr('string'),
  combinedFileName: attr('string'),
  feDetailReportFileName: attr('string'),
  pcContributionsFileName: attr('string'),
  pcDetailedEquityFileName: attr('string'),
  pledgesFileNames: attr(),
  transactionsFileNames: attr(),
  rufRecurringGiftsFileName: attr('string'),
  rufBalancesFileName: attr('string'),
  rufAmendmentsFileName: attr('string'),
});
